<template>
  <div>
    <el-upload
        :file-list="fileList"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        accept=".jpeg,.jpg,.png"
        action="/v1/api/mg/upload"
        list-type="picture-card">
      <i class="el-icon-plus"></i>
    </el-upload>
    <div v-if="tips" slot="tips">{{ tips }}</div>
    <el-dialog :modal="false" :visible.sync="dialogVisible" modal-append-to-body>
      <img :src="dialogImageUrl" alt="" width="100%">
    </el-dialog>
  </div>
</template>

<script>
import {filePath} from '@/utils/AwsUtils'
import {s3Url} from "@/utils/Constants";

export default {
  name: 'ImageUploader',
  props: {
    updatedFiles: {required: true, type: Array},
    tips: {required: false, type: String},
    emitFileObject: {required: false, type: Boolean, default: () => false}
  },
  data() {
    return {
      prefix: s3Url,
      dialogImageUrl: '',
      dialogVisible: false,
      files: []
    }
  },
  methods: {
    handleSuccess(res) {
      if (this.emitFileObject) {
        this.updatedFiles.push(res);
      } else {
        this.updatedFiles.push(res.path)
      }
      this.$emit('update:updatedFiles', this.updatedFiles);
      this.$emit('update:fids', res.id)
    },
    handleRemove(file) {
      const filePath = file.url
      const files = this.updatedFiles.filter((item) => filePath.indexOf(this.getFilePath(item)) === -1)
      this.$emit('update:updatedFiles', files)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    getFilePath(item) {
      if (item.hasOwnProperty('path')) {
        return item.path
      } else {
        return item
      }
    }
  },
  mounted() {
    if (!this.updatedFiles) {
      this.updatedFiles = []
    }
  },
  computed: {
    fileList() {
      return this.updatedFiles
          .map((item) => {
            let path = this.getFilePath(item)
            path = filePath(path)
            return {url: path};
          })
    }

  }

}
</script>

<style scoped>

</style>
